
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-523b42ca&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UploadButtonComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UploadButtonComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-523b42ca!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UploadButtonComponent.vue"),
  /* scopeId */
  "data-v-523b42ca",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/UploadButtonComponent.vue
// module id = 205
// module chunks = 2